import CropsPerformanceDashboardContainer from './containers/CropsPerformanceDashboardContainer';

export default CropsPerformanceDashboardContainer;
